import BaseBlockContent from "@sanity/block-content-to-react";
import SingleImage from "./singleImage";
import RichTextGallery from "./gallery";
import Embed from "./embed";
import PullQuote from "./pull-quote";
import SocialEmbed from "../shared/social-embed";

const serializers = {
  marks: {
    'External Link': ({ mark, children }) => {
      return (
          <a className={`text-blue-500 underline`} href={mark.href}>
            {children}
          </a>
      );
    },
    mailtoLink: ({ mark, children }) => {
      return (
          <a className={`text-blue-500 underline`} href={`mailto:${mark.mailto}`}>
            {children}
          </a>
      );
    },
    internalLink: ({ mark, children }) => {
      const reference = mark.reference;

      if (reference === undefined) {
        return <>{children}</>;
      }

      if (reference._type === "newsPost") {
        return (
          <a
            href={
              reference?.slug?.current
                ? `${serializers.section || "/"}news/${reference.slug.current}`
                : ``
            }
          >
            {children}
          </a>
        );
      }

      if (reference?.slug?.current !== undefined) {
        return <a href={reference?.slug?.current ?? ``}>{children}</a>;
      }
      return <a href={`${reference?.path ?? ``}`}>{children}</a>;
      //
    },
    color: ({ mark, children }) => {
      return (
        <span
          style={{
            color: mark?.reference?.code ? mark.reference.code : `inherit`,
          }}
        >
          {children}
        </span>
      );
    },
  },
  types: {
    block(props) {
      switch (props.node.style) {
        // Check for h1 in future news posts as this could be removed. h1 has been removed from Studio block formatting
        case "h1":
          return <h1>{props.children}</h1>;

        case "h2":
          return <h2>{props.children}</h2>;

        case "h3":
          return <h3>{props.children}</h3>;

        case "h4":
          return <h4>{props.children}</h4>;

        case "cite":
          return <cite>{props.children}</cite>;

        case "url":
          return <a href={props.href}>{props.children}</a>;

        default:
          return <p>{props.children}</p>;
      }
    },
    horizontalRule() {
      return <hr />;
    },
    singleImage(props) {
      return <SingleImage {...props.node} />;
    },
    gallery(props) {
      return <RichTextGallery {...props.node} />;
    },
    pullQuote(props) {
      return <PullQuote {...props.node} />;
    },
    embed(props) {
      return <Embed {...props.node} />;
    },
    socialEmbed(props) {
      return <SocialEmbed {...props.node} />;
    },
  },
};

const BlockContent = ({ blocks, section }) => {
  if (section !== undefined) {
    serializers.section = section;
  }
  return <BaseBlockContent blocks={blocks} serializers={serializers} />;
};

export default BlockContent;
